import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SetorAPIService {

  private baseUrl = `${environment.APIEndpoint}setor`;

  constructor(private http: HttpClient) { }

  getAll(pageNumber: number = 1, pageSize: number = 100, nome: string, departamentoId: number, setorId: number = null) {
    var params = "";

    if(departamentoId){
      params += `&departamentoId=${departamentoId}`;   
    }

    if(nome){
      params += `&nome=${nome}`;
    }

    if(setorId){
      params += `&setorId=${setorId}`;   
    }

    return this.http.get(this.baseUrl + `/listar-paginada?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`);
  }

  getLista(nome: string, departamentoId: number) {
    var params = ``;

    if(departamentoId){
      params += `?departamentoId=${departamentoId}`;   
    }



    return this.http.get(this.baseUrl + `/listar${params}`);
  }

  getById(id: number) {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  create(data: any) {
    return this.http.post(this.baseUrl, data);
  }

  update(id: number, data: any) {
    return this.http.put(`${this.baseUrl}/${id}`, data);
  }

  delete(id: number) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  getListaSetorAprovador() {
    return this.http.get(this.baseUrl + `/listar-setor-aprovador`);
  }
}
